<template>
	<Layout>
		<template>
			<ValidationObserver ref="observer" v-slot="{ handleSubmit }">
				<form @submit.prevent="handleSubmit(updatePreferences)">
					<article class="profile__column panel">
						<div class="panel__header">
							<span class="is-flex is-flex-direction-column is-justify-content-center">
								<h3 class="profile__name pt-0 is-semibold is-size-4">{{ $tc('menu.preferences', 2) }}</h3>
								<p class="is-size-6">{{ $t('profile.preferences') }}</p>
							</span> 
							<b-button v-if="isDesktop" id="button-profile-settings" tabindex="6" native-type="submit" type="is-primary save" :loading="loading" rounded>{{ $t('buttons.save') }}</b-button>
						</div>
						<div class="panel__body">
							<h3 class="profile__section mb-5 has-text-primary is-semibold is-size-5">{{ $tc('menu.settings', 2) }}</h3>
							<SelectWithValidation class="profile__field" tab="5" :label="$tc('fields.language')" name="language" size="is-medium" v-model="user.language">
								<option :value="l.language" v-for="l in languages" :key="l.id">{{ l.title }}</option>
							</SelectWithValidation>

							<SelectWithValidation class="profile__field" tab="6" :label="$tc('fields.theme')" name="theme" size="is-medium" v-model="user.theme">
								<option :value="t.theme" v-for="t in theme" :key="t.id">{{ t.title }}</option>
							</SelectWithValidation>

							<div class="is-flex is-justify-content-flex-end mb-3">
								<b-button v-if="!isDesktop" id="button-profile-settings" tabindex="7" native-type="submit" type="is-primary save" :loading="loading" rounded>{{ $t('buttons.save') }}</b-button>
							</div>
						</div>
					</article>
				</form>
			</ValidationObserver>
		</template>
	</Layout>
</template>

<script>
import Layout from '@/layouts/Profile'
import SelectWithValidation from '@/components/inputs/SelectWithValidation'
import { ValidationObserver } from 'vee-validate'
import Api from '@/services/api'
import { mapState, mapMutations } from 'vuex'
import { successToast, errorToast } from '@/mixins/toast'
import { responsive } from '@/mixins/responsive'

export default {
	name: 'Settings',
	mixins: [responsive],
	components: {
		Layout,
		ValidationObserver,
		SelectWithValidation
	},
	data() {
		return {
			loading: false,
			languages: [
				{
					id: 1,
					language: 'pt-BR',
					title: 'Português'
				},
				{
					id: 2,
					language: 'en-US',
					title: 'English'
				},
				{
					id: 3,
					language: 'es-ES',
					title: 'Español'
				}
			],
			theme: [
				{
					id: 1,
					theme: 'light',
					title: 'Light'
				},
				{
					id: 2,
					theme: 'dark',
					title: 'Dark'
				}
			]
		}
	},
	methods: {
		...mapMutations('user', ['setUser']),
		updatePreferences() {
			this.loading = true
			Api.post('users/preferences', this.user)
				.then(() => {
					this.setUser(this.user)
					successToast(this.$t('alerts.update.success', [this.$tc('menu.roles')]))
				})
				.catch(() => {
					errorToast(this.$t('settings_updated_error'))
				})
				.finally(() => {
					this.loading = false
				})
		}
	},
	computed: {
		...mapState('user', ['user'])
	}
}
</script>
